import { Component, OnInit } from '@angular/core';
import { SeoSettingService } from 'src/app/services/seo-setting.service';

@Component({
  selector: 'app-seo-header',
  templateUrl: './seo-header.component.html',
  styleUrls: ['./seo-header.component.css']
})
export class SeoHeaderComponent implements OnInit {

  seoTitle: string;
  seoDescription: string;
  seoKeyword: string;

  constructor(private _getSeoHeaderService: SeoSettingService) {
    this.seoTitle = "Ultrasound Machines Equipment for Sale - USC Shop";
    this.seoDescription = "USC provides high-quality medical imaging equipment. You can buy new or used machines from ultrasound to x-ray machines and repair services.";
    this.seoKeyword = "ultrasound machines sale";
  }

  ngOnInit() {
    this._getSeoHeaderService.seoTitleMethod.subscribe(title => this.seoTitle = title ? title : this.seoTitle);
    this._getSeoHeaderService.seoDescriptionMethod.subscribe(description => this.seoDescription = description ? description : this.seoDescription);
    this._getSeoHeaderService.seoKeywordMethod.subscribe(keyword => this.seoKeyword = keyword ? keyword : this.seoKeyword);
  }

}
